(function() {
  const initCollectionSliders = () => {
    const sliderSections = document.querySelectorAll('.collection-list-slider');
    
    sliderSections.forEach(section => {
      if (section.classList.contains('slider-initialized')) {
        return;
      }
      
      const sectionId = section.dataset.sectionId;
      const sliderId = `collection-slider-${sectionId}`;
      const sliderElement = document.querySelector(`#${sliderId} .collection-list-slider__swiper`);
      
      if (!sliderElement) return;
      
      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed) || 800;
      const autoplayDelay = parseInt(section.dataset.autoplayDelay) * 1000 || 5000;
      const slidesMobile = parseInt(section.dataset.slidesMobile) || 1;
      const slidesTablet = parseInt(section.dataset.slidesTablet) || 3;
      const slidesDesktop = parseInt(section.dataset.slidesDesktop) || 4;
      const showArrows = section.dataset.showArrows === 'true';
      
      const prevButton = section.querySelector('.swiper-button-prev');
      const nextButton = section.querySelector('.swiper-button-next');
      const pagination = section.querySelector('.swiper-pagination');
      
      let swiperConfig = {
        slidesPerView: slidesMobile,
        spaceBetween: 20,
        loop: true,
        speed: autoplaySpeed,
        watchOverflow: true,
        autoHeight: false,
        
        breakpoints: {
          576: {
            slidesPerView: Math.min(slidesMobile + 1, slidesTablet),
            spaceBetween: 20
          },
          750: {
            slidesPerView: slidesTablet,
            spaceBetween: 24
          },
          990: {
            slidesPerView: slidesDesktop,
            spaceBetween: 30
          }
        },
        
        navigation: showArrows ? {
          nextEl: nextButton,
          prevEl: prevButton,
        } : false,
        
        pagination: {
          el: pagination,
          clickable: true,
          type: 'bullets',
        },
        
        on: {
          init: function() {
            section.classList.add('slider-initialized');
            updateNavigationVisibility(this, section);
          },
          
          resize: function() {
            updateNavigationVisibility(this, section);
          },
          
          slideChange: function() {
            if (this.pagination) {
              this.pagination.render();
              this.pagination.update();
            }
          }
        }
      };
      
      // Only add autoplay if explicitly enabled
      if (autoplay === true) {
        swiperConfig.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }
      
      const swiper = new Swiper(sliderElement, swiperConfig);
      
      section.swiper = swiper;
    });
  };
  
  const updateNavigationVisibility = (swiper, section) => {
    const prevButton = section.querySelector('.swiper-button-prev');
    const nextButton = section.querySelector('.swiper-button-next');
    const pagination = section.querySelector('.swiper-pagination');
    
    if (!swiper.slides || swiper.slides.length <= swiper.params.slidesPerView) {
      if (prevButton) prevButton.classList.add('hide');
      if (nextButton) nextButton.classList.add('hide');
      if (pagination) pagination.classList.add('hide');
    } else {
      if (prevButton) prevButton.classList.remove('hide');
      if (nextButton) nextButton.classList.remove('hide');
      if (pagination) pagination.classList.remove('hide');
    }
  };
  
  const destroySliders = () => {
    const sliderSections = document.querySelectorAll('.collection-list-slider');
    
    sliderSections.forEach(section => {
      if (section.swiper && typeof section.swiper.destroy === 'function') {
        section.swiper.destroy(true, true);
        section.classList.remove('slider-initialized');
        delete section.swiper;
      }
    });
  };
  
  const reinitializeSliders = () => {
    destroySliders();
    setTimeout(() => {
      initCollectionSliders();
    }, 100);
  };
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSliders);
  } else {
    initCollectionSliders();
  }
  
  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.collection-list-slider')) {
      setTimeout(() => {
        initCollectionSliders();
      }, 100);
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    const section = event.target.querySelector('.collection-list-slider');
    if (section && section.swiper) {
      section.swiper.destroy(true, true);
      delete section.swiper;
    }
  });
  
  document.addEventListener('shopify:section:reorder', function() {
    reinitializeSliders();
  });
  
  // Handle window resize with debounce
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const sliderSections = document.querySelectorAll('.collection-list-slider');
      sliderSections.forEach(section => {
        if (section.swiper) {
          section.swiper.update();
          updateNavigationVisibility(section.swiper, section);
        }
      });
    }, 250);
  });
})();